export const PluginNames = {
  Camera: 'Camera',
  PushNotifications: 'PushNotifications',
};
